import React from "react";
import Table from "./table";
import { useModalHook } from "../../../../functions/useModalHook";

const UsersContent = () => {
  const { setModal } = useModalHook();
  return (
    <div className="flex flex-1 flex-col gap-5">
      <div className="flex flex-row justify-between items-center">
        <span className="flex text-[22px] font-medium">
          Tous les utilisateurs
        </span>
        <button
          onClick={() => {
            setModal("create_user");
          }}
          className="flex px-12 py-2 bg-primary hover:bg-hover active:bg-active rounded-md"
        >
          <span className="flex text-white">Ajouter utilisateur</span>
        </button>
      </div>
      <Table />
    </div>
  );
};

export default UsersContent;
